import {message} from '@common/i18n/message';
import {MessageDescriptor} from '@common/i18n/message-descriptor';

export interface QrPreset {
  id: string;
  label: MessageDescriptor;
  fg: string;
  bg: string;
}

export const QrPresets: QrPreset[] = [
  {id: 'classic', label: message('Classic'), fg: '000000', bg: 'ffffff'},
  {id: 'inverted', label: message('Inverted'), fg: 'ffffff', bg: '000000'},
  {id: 'midnight', label: message('Midnight'), fg: '0f172a', bg: 'e0f2fe'},
  {id: 'forest', label: message('Forest'), fg: '14532d', bg: 'f0fdf4'},
  {id: 'sunset', label: message('Sunset'), fg: '7c2d12', bg: 'fff7ed'},
  {id: 'berry', label: message('Berry'), fg: '831843', bg: 'fdf2f8'},
  {id: 'ocean', label: message('Ocean'), fg: '075985', bg: 'f0f9ff'},
  {id: 'royal', label: message('Royal Purple'), fg: '4c1d95', bg: 'f5f3ff'},
  {id: 'gold', label: message('Gold'), fg: '854d0e', bg: 'fefce8'},
  {id: 'slate', label: message('Slate'), fg: '1e293b', bg: 'f1f5f9'},
];
